import { Injectable } from '@angular/core';
import { BuildForm } from 'src/app/shared/models/formulir/build-form.model';
import { BuildFormApiService } from '../../api/formulir/build-form.api.service';
import { DataService } from '../data.service';

interface CreateBuildFormPayload {
  namaForm: string;
  idInstallasi: number;
  navigationHead: string;
  navigationChild?: string;
  details: {
    name: string;
    nameAttribute: string;
    inputType: string;
    validation?: boolean;
    attributeData?: string;
    id?: number;
  }[];
  target?: number;
}

@Injectable({
  providedIn: 'root',
})
export class BuildFormDataService implements DataService<BuildForm> {
  constructor(private buildFormApiService: BuildFormApiService) {}

  public getAll(params?: any) {
    return this.buildFormApiService.getAll(params);
  }

  public getById(id: number) {
    return this.buildFormApiService.getById(id);
  }

  public getBuildFormNavigationSuggestions() {
    return this.buildFormApiService.getBuildFormNavigationSuggestions();
  }

  public createBuildForm(data: CreateBuildFormPayload) {
    return this.buildFormApiService.createBuildForm(data);
  }

  public update(idBuildForm: number, data: any) {
    return this.buildFormApiService.update(idBuildForm, data);
  }

  public getFromSourceTableById(idBuildForm: number, idItem: number | string) {
    return this.buildFormApiService.getFromSourceTableById(idBuildForm, idItem);
  }

  public getFromSourceTable(params?: {
    idBuildForm: number;
    start?: string;
    end?: string;
    installasi?: string;
    idPasien?: string;
    idLogStatus?: string;
    dateInputStart?: string;
    dateInputEnd?: string;
  }) {
    return this.buildFormApiService.getFromSourceTable(params);
  }

  public insertToSourceTable(idBuildForm: number, data: any) {
    return this.buildFormApiService.insertToSourceTable(idBuildForm, data);
  }

  public updateDataSourceTable(idBuildForm: number, idItem: number | string, data: any) {
    return this.buildFormApiService.updateDataSourceTable(idBuildForm, idItem, data);
  }

  public deleteBuildForm(idBuildForm: number) {
    return this.buildFormApiService.deleteBuildForm(idBuildForm);
  }
}
